import Config from '@config';
import { initializeAuditApi } from '@gasbi/shared/common/features';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { AuditEntityTypeName } from './types';

const audit = initializeAuditApi<AuditEntityTypeName>({
  // Shared AuditController is mapped at the root (MapControllers), not under the /api group.
  baseUrl: `${Config.VITE_API_URL}/audit`,
  baseQuery: axiosBaseQuery,
});

export const {
  auditApi,
  useGetAuditEntryDetailsQuery,
  useGetAuditEntriesInfiniteQuery,
  useGetAuditEntriesByServiceInfiniteQuery,
  useGetEntityTypeNamesByServiceQuery,
} = audit;
